var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"inset":"","app":"","color":"primary","height":"42"}},[_c('v-col',{staticClass:"text-center lighttext--text",attrs:{"cols":"12"}},[_vm._v(" Versão: 3.2.1 ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }